export default "cb4d42f";



// WEBPACK FOOTER //
// ./src/version.ts